export default {
	'custom-delete': {
		width: 35,
		height: 35,
		/* eslint-disable max-len */
		d: 'M10.75,25.375 C10.75,26.6125 11.7625,27.625 13,27.625 L22,27.625 C23.2375,27.625 24.25,26.6125 24.25,25.375 L24.25,11.875 L10.75,11.875 L10.75,25.375 Z M25.375,8.5 L21.4375,8.5 L20.3125,7.375 L14.6875,7.375 L13.5625,8.5 L9.625,8.5 L9.625,10.75 L25.375,10.75 L25.375,8.5 Z'
	}
};
